import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { TherapistGroupService } from '../../../therapist-group.service';
import {
  ITherapistGroup,
  ITherapistGroupUpdate,
  THERAPIST_GROUP_TTL_ES
} from '../../../therapist-group.interface';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';

@Component({
  selector: 'pg-therapist-group-update',
  templateUrl: './therapist-group-update.component.html'
})
export class TherapistGroupUpdateComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  constructor(
    private fb: FormBuilder,
    private serviceBase: TherapistGroupService
  ) {
    super(THERAPIST_GROUP_TTL_ES, serviceBase);
  }

  ngOnInit() {
    const item = this.row as ITherapistGroup;
    this.fg = this.fb.group({
      description: [item.description, [Validators.required]]
    });
  }

  onSubmit() {
    this.updateItem$(this.fg.value as ITherapistGroupUpdate);
  }
}
